module.exports = __webpack_public_path__ + "img/SACDS.dfca824b.png";